export default "__VITE_ASSET__BoD5c12___"